import { gql } from '@apollo/client';

export const CREATE_CATEGORY_MUTATION = gql`
    mutation createCategory($input: CreateCategoryInput!) {
        result: createCategory(input: $input) {
            id
            name
            description
            brand {
                name
                id
            }
            locales {
                code
                name
                description
            }
        }
    }
`;
